import * as TogglePrimitive from '@radix-ui/react-toggle'
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react'

import { cn } from './utils'

export interface ToggleProps extends ComponentPropsWithoutRef<typeof TogglePrimitive.Root> {
  size?: 'sm' | 'md'
  variant?: 'default' | 'outline'
}

/** A pressable on/off button (tool rail buttons, snapping toggles). */
export const Toggle = forwardRef<ElementRef<typeof TogglePrimitive.Root>, ToggleProps>(function Toggle(
  { className, size = 'md', variant = 'default', ...props },
  ref,
) {
  return (
    <TogglePrimitive.Root
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-xl text-sm font-medium text-ink-2 transition-colors',
        'hover:bg-paper-2 hover:text-ink focus-visible:focus-ring disabled:pointer-events-none disabled:opacity-50',
        'data-[state=on]:bg-accent-soft data-[state=on]:text-ink',
        variant === 'outline' && 'border border-line',
        size === 'sm' ? 'h-9 min-w-9 px-2.5 [&_svg]:size-4' : 'h-11 min-w-11 px-3 [&_svg]:size-5',
        className,
      )}
      {...props}
    />
  )
})
